import { Route, Switch } from "react-router-dom";

import Layout from "./containers/Layout";
import asyncComponent from "./hoc/asyncComponent";

// import Home from "./containers/Home";
const asyncHome = asyncComponent(() => {
    return import("./containers/Home");
});

// import Projects from "./containers/Projects";
const asyncProjects = asyncComponent(() => {
    return import("./containers/Projects");
});

// import Error from "./containers/Error";
const asyncError = asyncComponent(() => {
    return import("./containers/Error");
});

const App = () => {
    return (
        <Layout>
            <Switch>
                <Route
                    basename={process.env.PUBLIC_URL}
                    exact
                    path="/"
                    component={asyncHome}
                />
                <Route
                    basename={process.env.PUBLIC_URL}
                    path="/projects"
                    component={asyncProjects}
                />
                <Route
                    basename={process.env.PUBLIC_URL}
                    component={asyncError}
                />
            </Switch>
        </Layout>
    );
};

export default App;
